// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"571":"p-dennis-k7m2","638":"below"}[chunkId] || chunkId) + "." + {"48":"9ed0b949","186":"623acaf6","571":"7e94d35a","638":"53c3e95b","862":"ee8936fe","874":"e00b2512"}[chunkId] + ".chunk.js";
};